import { render } from "./ModalGift.vue?vue&type=template&id=7e70217e&scoped=true"
import script from "./ModalGift.vue?vue&type=script&lang=js"
export * from "./ModalGift.vue?vue&type=script&lang=js"

import "./ModalGift.vue?vue&type=style&index=0&id=7e70217e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e70217e"]])

export default __exports__